import { MdOutlineZoomOutMap, MdOutlineZoomInMap } from "react-icons/md";
import { useState } from "react";

const Receipt = ({ pkg, price }) => {
  const [isOpen, setIsOpen] = useState(false);
  const togglePopup = () => setIsOpen(!isOpen);
  return (
    <div>
      {/*  ใบเสร็จ */}
      {!isOpen && (
        <div className="absolute top-[35vh] right-[5vw]  flex justify-center items-center flex-col min-h-screen bg-transparent z-30">
          <div className="flex w-[300px] h-3 justify-center overflow-hidden translate-y-[0.5px]">
            {[...Array(20)].map((_, index) => (
              <div
                key={index}
                className={`${
                  index === 0 || index === 19 ? "w-2" : "w-4"
                } h-3 bg-white`}
                style={{
                  clipPath:
                    index === 0
                      ? "polygon(100% 100%, 0% 100%, 0% 0%)" // ครึ่งแรก
                      : index === 19
                      ? "polygon(0% 100%, 100% 0%, 100% 100%)" // ครึ่งสุดท้าย
                      : "polygon(50% 0%, 0% 100%, 100% 100%)", // สามเหลี่ยมเต็ม
                }}
              />
            ))}
          </div>
          <div
            className="relative w-[300px] h-auto p-4 overflow-hidden"
            style={{
              background:
                "linear-gradient(180deg, #FFFFFF 0%, #F1F1F1 48%, #D8D8D8 100%)",
            }}
          >
            {/* เนื้อหาใบเสร็จ */}
            <div className="relative z-10 text-center mt-2 px-3">
              <h1 className="text-xl font-semibold ">TIPSCROSSBORDER</h1>
              <p className="text-[0.625rem] leading-[109%] tracking-normal font-light">
                Address : 28/65 Floor 6 Soi Ratchadapisek 19, Ratchadaphisek
                Subdistrict, Din Daeng District, Bangkok 10400
              </p>
            </div>

            <hr className="my-3 border-dashed opacity-100" />

            <div className="text-center my-2">
              <h2 className="font-normal text-xl">CASH RECEIPT</h2>
            </div>

            <hr className="my-3 border-dashed opacity-100" />

            <div className="flex justify-between text-lg font-medium mt-2">
              <p>Total</p>
              <p>{price}.00 RM</p>
            </div>
            <div className="flex justify-between text-xs font-light">
              <p>Cash</p>
              <p>{price}.00 RM</p>
            </div>
            <div className="flex justify-between text-xs font-light mb-2">
              <p>Change</p>
              <p>0.00 RM</p>
            </div>

            <hr className="my-3 border-dashed opacity-100" />

            <div className="text-[9px] my-4">
              {pkg === "gold" ? (
                <div>
                  <div className="font-bold mb-1">
                    Protection for third party
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Third party for death and bodily injury(Third Party)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          580,000.- Baht / Person
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          For the maximum limit
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          10,000,000- Baht / Time
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Damage for property (third Party)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          1,000,000.- Baht / Time
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="font-bold mb-1">
                    Protection for your own
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Damage for car ( your car coliding with a car with a
                          registered license) (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          50,000.- Baht / Time
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Death, loss of limbs, and permanent disability (per
                          person) (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          100,000.- Baht / Person
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Medical expenses (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          100,000.- Baht / Person
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Bail bond guarantee (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          200,000.- Baht / Time
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Including towing service fee (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          First 100 Km / Excess 30 Baht per 1 Km.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="font-bold mb-1">
                    Extra for Driver
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          1.In case of death dismemberment Loss of sight due to
                          accident (including murder or assault)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          150,000.-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          2. Medical treatment for injuries from accidents (per
                          each accident)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          50,000.-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          3. Transport for emergency medical treatment and
                          moving back to their hometowns
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          50,000.-
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : pkg === "silver" ? (
                <div>
                  <div className="font-bold mb-1">
                    Protection for third party
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Third party for death and bodily injury(Third Party)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          580,000.- Baht / Person
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          For the maximum limit
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          10,000,000- Baht / Time
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Damage for property (third Party)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          1,000,000.- Baht / Time
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="font-bold mb-1">
                    Protection for your own
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Damage for car ( your car coliding with a car with a
                          registered license) (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          -
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Death, loss of limbs, and permanent disability (per
                          person) (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right flex-col">
                          <div>500,000.- Baht / Person (Passenger)</div>
                          <div>35,000.- Baht / Person (Driver)</div>
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Medical expenses (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right flex-col">
                          <div>80,000.- Baht / Person (Passenger)</div>
                          <div>30,000.- Baht / Person (Driver)</div>
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Bail bond guarantee (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          -
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Including towing service fee (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          -
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="font-bold mb-1">
                    Extra for Driver
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          1.In case of death dismemberment Loss of sight due to
                          accident (including murder or assault)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          150,000.-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          2. Medical treatment for injuries from accidents (per
                          each accident)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          50,000.-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          3. Transport for emergency medical treatment and
                          moving back to their hometowns
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          50,000.-
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : pkg === "ruby" ? (
                <div>
                  <div className="font-bold mb-1">
                    Protection for third party
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Third party for death and bodily injury(Third Party)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          580,000.- Baht / Person
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          For the maximum limit
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          10,000,000- Baht / Time
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Damage for property (third Party)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          1,000,000.- Baht / Time
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="font-bold mb-1">
                    Protection for your own
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Damage for car ( your car coliding with a car with a
                          registered license) (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          -
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Death, loss of limbs, and permanent disability (per
                          person) (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          100,000.- Baht / Person
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Medical expenses (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          100,000.- Baht / Person
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Bail bond guarantee (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          200,000.- Baht / Time
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Including towing service fee (your own)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          -
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="font-bold mb-1">
                    Extra for Driver
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          1.In case of death dismemberment Loss of sight due to
                          accident (including murder or assault)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          150,000.-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          2. Medical treatment for injuries from accidents (per
                          each accident)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          50,000.-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          3. Transport for emergency medical treatment and
                          moving back to their hometowns
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          50,000.-
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="font-bold mb-1">
                    Coverage
                    <div className="font-light">
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Personal Accident, Loss of life, Dismemberment, Loss
                          of sight or Total Permanent Disability (Included
                          Murdered and Assault coverage)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          600,000.-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Accidental Medical Expenses (per each accident)
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          100,000-
                        </div>
                      </div>
                      <div class="flex space-x-4 mb-1 ml-2">
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap">
                          Emergency Medical Evacuation and Repatriation
                        </div>
                        <div class="basis-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-right">
                          100,000.-
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="font-bold mb-1">
                    Condition(Travel accident Insurance)
                    <div className="font-light">
                      <div class="flex mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          1. For the insured who is at least 1 year old and not
                          more than 70 years old (calculated from the current
                          year minus the year of birth) on the date of insurance
                          application.
                        </div>
                      </div>
                      <div class="flex  mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          2.This insurance plan Provides protection for insured
                          persons traveling within Thailand and coverage for
                          each insured person. and ends within the insurance
                          period specified in the insurance policy table.
                        </div>
                      </div>
                      <div class="flex  mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          3. The travel period begins when the insured leaves
                          his or her residence for the trip and continues until
                          the insured returns to his or her residence.
                        </div>
                      </div>
                      <div class="flex  mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          4.Benefits for moving for emergency treatment Provides
                          coverage only in the event that the insured is injured
                          in a sudden and unpredictable accident that must occur
                          during the trip from the place of residence. In the
                          event that the insured is injured in an accident that
                          occurs suddenly rise.
                        </div>
                      </div>
                      <div class="flex mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          5.One insured person can purchase travel insurance.
                          This insurance plan has a maximum of 1 policy per 1
                          trip.
                        </div>
                      </div>
                      <div class="flex mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          6. The above premium rates are the premiums for 1
                          insured person.
                        </div>
                      </div>
                      <div class="flex mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          7. This insurance plan does not cover accidents while
                          driving or riding a motorcycle.
                        </div>
                      </div>
                      <div class="flex  mb-1 ml-2">
                        <div className="basis-[95%] overflow-hidden text-ellipsis whitespace-nowrap">
                          8. Terms, conditions, protection and other exceptions
                          as specified in the domestic travel insurance policy.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <hr className="my-2 border-dashed opacity-100" />

            <div className="text-center mt-4">
              <p className="font-bold text-xl">THANK YOU</p>
              <p className="font-normal text-[0.5rem]">
                Please visit us again.
              </p>
            </div>
            <div className="absolute bottom-1 left-4 text-[0.5rem] inline-flex">
              <button
                onClick={togglePopup}
                className="bg-transparent text-black w-4 h-4"
              >
                <MdOutlineZoomOutMap className="w-4 h-4" />
              </button>
              <div className="flex justify-center items-center pl-1">
                see more detail
              </div>
            </div>
          </div>
          <div className="flex w-[300px] h-3 justify-center overflow-hidden -translate-y-[0.5px]">
            {[...Array(20)].map((_, index) => (
              <div
                key={index}
                className={`${
                  index === 0 || index === 19 ? "w-2" : "w-4"
                } h-3 bg-[#D8D8D8]`}
                style={{
                  clipPath:
                    index === 0
                      ? "polygon(0% 100%, 100% 0%, 0% 0%)" // ครึ่งแรก
                      : index === 19
                      ? "polygon(100% 100%, 100% 0%, 0% 0%)" // ครึ่งสุดท้าย
                      : "polygon(50% 100%, 100% 0%, 0% 0%)", // สามเหลี่ยมเต็ม
                }}
              />
            ))}
          </div>
        </div>
      )}
      {/* ซูมใบเสร็จ */}
      {isOpen && (
        <div className="fixed inset-0 w-screen  min-h-screen bg-black bg-opacity-50 z-20 overflow-auto">
          <div className=" flex justify-center items-center flex-col bg-transparent z-30 my-[5vh]">
            <div className="flex w-[400px] h-4 justify-center overflow-hidden translate-y-[0.1px]">
              {[...Array(20)].map((_, index) => (
                <div
                  key={index}
                  className={`${
                    index === 0 || index === 19 ? "w-[20px]" : "w-[40px]"
                  } h-4 bg-white`}
                  style={{
                    clipPath:
                      index === 0
                        ? "polygon(100% 100%, 0% 100%, 0% 0%)" // ครึ่งแรก
                        : index === 19
                        ? "polygon(0% 100%, 100% 0%, 100% 100%)" // ครึ่งสุดท้าย
                        : "polygon(50% 0%, 0% 100%, 100% 100%)", // สามเหลี่ยมเต็ม
                  }}
                />
              ))}
            </div>
            <div
              className="relative w-[400px] px-6 py-8 "
              style={{
                background:
                  "linear-gradient(180deg, #FFFFFF 0%, #F1F1F1 48%, #D8D8D8 100%)",
              }}
            >
              {/* เนื้อหาใบเสร็จ */}
              <div className="relative z-10 text-center mt-2 px-3">
                <h1 className="text-xl font-semibold ">TIPSCROSSBORDER</h1>
                <p className="text-[0.625rem] leading-[109%] tracking-normal font-light">
                  Address : 28/65 Floor 6 Soi Ratchadapisek 19, Ratchadaphisek
                  Subdistrict, Din Daeng District, Bangkok 10400
                </p>
              </div>

              <hr className="my-3 border-dashed opacity-100" />

              <div className="text-center my-2">
                <h2 className="font-normal text-xl">CASH RECEIPT</h2>
              </div>

              <hr className="my-3 border-dashed opacity-100" />

              <div className="flex justify-between text-lg font-medium mt-2">
                <p>Total</p>
                <p>{price}.00 RM</p>
              </div>
              <div className="flex justify-between text-xs font-light">
                <p>Cash</p>
                <p>{price}.00 RM</p>
              </div>
              <div className="flex justify-between text-xs font-light mb-2">
                <p>Change</p>
                <p>0.00 RM</p>
              </div>

              <hr className="my-3 border-dashed opacity-100" />

              <div className="text-[9px] my-4 leading-2">
                {pkg === "gold" ? (
                  <div>
                    <div className="font-bold mb-1">
                      Protection for third party
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Third party for death and bodily injury(Third Party)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            580,000.- Baht / Person
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            For the maximum limit
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            10,000,000- Baht / Time
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Damage for property (third Party)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            1,000,000.- Baht / Time
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="font-bold mb-1">
                      Protection for your own
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Damage for car ( your car coliding with a car with a
                            registered license) (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            50,000.- Baht / Time
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Death, loss of limbs, and permanent disability (per
                            person) (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            100,000.- Baht / Person
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Medical expenses (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            100,000.- Baht / Person
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Bail bond guarantee (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            200,000.- Baht / Time
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Including towing service fee (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            First 100 Km / Excess 30 Baht per 1 Km.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="font-bold mb-1">
                      Extra for Driver
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            1.In case of death dismemberment Loss of sight due
                            to accident (including murder or assault)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            150,000.-
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            2. Medical treatment for injuries from accidents
                            (per each accident)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            50,000.-
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            3. Transport for emergency medical treatment and
                            moving back to their hometowns
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            50,000.-
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : pkg === "silver" ? (
                  <div>
                    <div className="font-bold mb-1">
                      Protection for third party
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis ">
                            Third party for death and bodily injury(Third Party)
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis text-right">
                            580,000.- Baht / Person
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis">
                            For the maximum limit
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis text-right">
                            10,000,000- Baht / Time
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis">
                            Damage for property (third Party)
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis text-right">
                            1,000,000.- Baht / Time
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="font-bold mb-1">
                      Protection for your own
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis">
                            Damage for car ( your car coliding with a car with a
                            registered license) (your own)
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsi text-right">
                            -
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Death, loss of limbs, and permanent disability (per
                            person) (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right flex-col">
                            <div>500,000.- Baht / Person (Passenger)</div>
                            <div>35,000.- Baht / Person (Driver)</div>
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Medical expenses (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right flex-col">
                            <div>80,000.- Baht / Person (Passenger)</div>
                            <div>30,000.- Baht / Person (Driver)</div>
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis">
                            Bail bond guarantee (your own)
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis text-right">
                            -
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis">
                            Including towing service fee (your own)
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis text-right">
                            -
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="font-bold mb-1">
                      Extra for Driver
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis ">
                            1.In case of death dismemberment Loss of sight due
                            to accident (including murder or assault)
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis  text-right">
                            150,000.-
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis ">
                            2. Medical treatment for injuries from accidents
                            (per each accident)
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis  text-right">
                            50,000.-
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[60%] overflow-hidden text-ellipsis">
                            3. Transport for emergency medical treatment and
                            moving back to their hometowns
                          </div>
                          <div class="basis-[40%] overflow-hidden text-ellipsis text-right">
                            50,000.-
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : pkg === "ruby" ? (
                  <div>
                    <div className="font-bold mb-1">
                      Protection for third party
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Third party for death and bodily injury(Third Party)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            580,000.- Baht / Person
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            For the maximum limit
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            10,000,000- Baht / Time
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Damage for property (third Party)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            1,000,000.- Baht / Time
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="font-bold mb-1">
                      Protection for your own
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Damage for car ( your car coliding with a car with a
                            registered license) (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            -
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Death, loss of limbs, and permanent disability (per
                            person) (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            100,000.- Baht / Person
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Medical expenses (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            100,000.- Baht / Person
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Bail bond guarantee (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            200,000.- Baht / Time
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Including towing service fee (your own)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            -
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="font-bold mb-1">
                      Extra for Driver
                      <div className="font-light">
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            1.In case of death dismemberment Loss of sight due
                            to accident (including murder or assault)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            150,000.-
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            2. Medical treatment for injuries from accidents
                            (per each accident)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            50,000.-
                          </div>
                        </div>
                        <div class="flex space-x-4 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            3. Transport for emergency medical treatment and
                            moving back to their hometowns
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            50,000.-
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="font-bold mb-1">
                      Coverage
                      <div className="font-light">
                        <div class="flex space-x-4 mb-1 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Personal Accident, Loss of life, Dismemberment, Loss
                            of sight or Total Permanent Disability (Included
                            Murdered and Assault coverage)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            600,000.-
                          </div>
                        </div>
                        <div class="flex space-x-4 mb-1 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Accidental Medical Expenses (per each accident)
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            100,000-
                          </div>
                        </div>
                        <div class="flex space-x-4 mb-1 ml-2">
                          <div class="basis-[50%] overflow-hidden text-ellipsis">
                            Emergency Medical Evacuation and Repatriation
                          </div>
                          <div class="basis-[50%] overflow-hidden text-ellipsis text-right">
                            100,000.-
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="font-bold mb-1">
                      Condition(Travel accident Insurance)
                      <div className="font-light">
                        <div class="flex mb-1 ml-2">
                          <div className="basis-[90%] overflow-hidden text-ellipsis">
                            1. For the insured who is at least 1 year old and
                            not more than 70 years old (calculated from the
                            current year minus the year of birth) on the date of
                            insurance application.
                          </div>
                        </div>
                        <div class="flex  mb-1 ml-2">
                          <div className="basis-[95%] overflow-hidden text-ellipsis">
                            2.This insurance plan Provides protection for
                            insured persons traveling within Thailand and
                            coverage for each insured person. and ends within
                            the insurance period specified in the insurance
                            policy table.
                          </div>
                        </div>
                        <div class="flex  mb-1 ml-2">
                          <div className="basis-[95%] overflow-hidden text-ellipsis">
                            3. The travel period begins when the insured leaves
                            his or her residence for the trip and continues
                            until the insured returns to his or her residence.
                          </div>
                        </div>
                        <div class="flex  mb-1 ml-2">
                          <div className="basis-[95%] overflow-hidden text-ellipsis">
                            4.Benefits for moving for emergency treatment
                            Provides coverage only in the event that the insured
                            is injured in a sudden and unpredictable accident
                            that must occur during the trip from the place of
                            residence. In the event that the insured is injured
                            in an accident that occurs suddenly rise.
                          </div>
                        </div>
                        <div class="flex mb-1 ml-2">
                          <div className="basis-[95%] overflow-hidden text-ellipsis">
                            5.One insured person can purchase travel insurance.
                            This insurance plan has a maximum of 1 policy per 1
                            trip.
                          </div>
                        </div>
                        <div class="flex mb-1 ml-2">
                          <div className="basis-[95%] overflow-hidden text-ellipsis">
                            6. The above premium rates are the premiums for 1
                            insured person.
                          </div>
                        </div>
                        <div class="flex mb-1 ml-2">
                          <div className="basis-[95%] overflow-hidden text-ellipsis">
                            7. This insurance plan does not cover accidents
                            while driving or riding a motorcycle.
                          </div>
                        </div>
                        <div class="flex  mb-1 ml-2">
                          <div className="basis-[95%] overflow-hidden text-ellipsis">
                            8. Terms, conditions, protection and other
                            exceptions as specified in the domestic travel
                            insurance policy.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <hr className="my-2 border-dashed opacity-100" />

              <div className="text-center mt-4">
                <p className="font-bold text-xl">THANK YOU</p>
                <p className="font-normal text-[0.5rem]">
                  Please visit us again.
                </p>
              </div>
              <div className="absolute bottom-1 left-4 text-[0.5rem] inline-flex">
                <button
                  onClick={togglePopup}
                  className="bg-transparent text-black w-6 h-6"
                >
                  <MdOutlineZoomInMap className="w-full h-full" />
                </button>
                <div className="flex items-center justify-center pl-1 align-text-bottom">
                  return
                </div>
              </div>
            </div>
            <div className="flex w-[400px] h-4 justify-center overflow-hidden -translate-y-[0.1px]">
              {[...Array(20)].map((_, index) => (
                <div
                  key={index}
                  className={`${
                    index === 0 || index === 19 ? "w-[20px]" : "w-[40px]"
                  } h-4 bg-[#D8D8D8]`}
                  style={{
                    clipPath:
                      index === 0
                        ? "polygon(0% 100%, 100% 0%, 0% 0%)" // ครึ่งแรก
                        : index === 19
                        ? "polygon(100% 100%, 100% 0%, 0% 0%)" // ครึ่งสุดท้าย
                        : "polygon(50% 100%, 100% 0%, 0% 0%)", // สามเหลี่ยมเต็ม
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Receipt;
